export default __webpack_public_path__ + "static/media/8.e3ff1839.jpg";